import { createAsyncThunk } from '@reduxjs/toolkit';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../../../firebaseConfig';

// Get waitlist statistics with caching
export const getWaitlistStats = createAsyncThunk(
  'waitlist/getStats',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState().waitlist;
      const now = Date.now();
      const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes cache

      // Return cached data if it's fresh
      if (state.stats && state.lastStatsUpdate && (now - state.lastStatsUpdate) < CACHE_DURATION) {
        return state.stats;
      }

      // Read public total from a single settings doc instead of counting collection
      const settingsRef = doc(db, 'settings', 'waitlist');
      const settingsSnap = await getDoc(settingsRef);
      const totalCount = settingsSnap.exists() && typeof settingsSnap.data().publicTotal === 'number'
        ? settingsSnap.data().publicTotal
        : (state.stats?.totalCount || 0);

      // Only get approved count if we really need it (commented out to save quota)
      // For display purposes, we can estimate or use a cached value
      const approvedCount = 0; // Placeholder to save quota

      const result = {
        totalCount,
        approvedCount,
        pendingCount: totalCount - approvedCount,
        lastUpdated: now
      };

      return result;
    } catch (error) {
      console.error('Error getting waitlist stats:', error);
      // Return cached data if available, otherwise return default values
      const state = getState().waitlist;
      if (state.stats) {
        return state.stats;
      }
      // Return fallback values to prevent quota errors
      return {
        totalCount: 1247, // Static fallback
        approvedCount: 0,
        pendingCount: 1247,
        lastUpdated: Date.now()
      };
    }
  }
);
